
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recently-deleted",
      function () {
        return require("private-next-pages/recently-deleted.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recently-deleted"])
      });
    }
  